import { memo } from 'react'
import { withRouter } from 'react-router-dom'
import { sessionStore } from '@/utils/storage'
import CommonFunc from '@/utils/common-func'
import BasicStep from '../BasicStep/BasicStep'
import { useSessionStorageField } from '@/hooks/useSessionStorage'
const PptStep = ({ history, step }: any) => {
  const [payment_state] = useSessionStorageField('createPPTData', 'payment_state', 0)
  const LIST = [{ label: '上传资料' }, { label: '确定大纲' }, { label: '选择主题' }, { label: '生成PPT' }]
  const stpe1Data = ['outLine']
  const stpe2Data = ['theme', 'galleryActive', 'rightActive']
  const stpe3Data = ['resultPage', 'selectPageInfo', 'rightInfo', 'selectRightIndex', 'selectPageIndex', 'isSure', 'historyId']
  const onConfirm = (step: number) => {
    const cacheData = sessionStore.get('createPPTData', {}) as any
    if (step == 1) {
      const createPPTData = CommonFunc.omit(cacheData, [...stpe1Data, ...stpe2Data, stpe3Data])
      createPPTData.pathname = '/createPPT'
      sessionStore.set('createPPTData', createPPTData)
      history.push('/createPPT')
    }
    if (step == 2) {
      const createPPTData = CommonFunc.omit(cacheData, [...stpe2Data, stpe3Data])
      createPPTData.pathname = '/surePPTCatalog'
      sessionStore.set('createPPTData', createPPTData)
      history.push('/surePPTCatalog')
    }
    if (step == 3) {
      const createPPTData = CommonFunc.omit(cacheData, stpe3Data)
      createPPTData.pathname = '/selectPPTTheme'
      sessionStore.set('createPPTData', createPPTData)
      history.push('/selectPPTTheme')
    }
  }
  return <BasicStep list={LIST} step={step} isGradient={true} onConfirm={onConfirm} payment_state={payment_state} type={5} />
}

export default memo(withRouter(PptStep))
